module.exports = __webpack_public_path__ + "media/social/facebook_link_white-3e21b01a.svg";